<!-- Forward Inquiry to Sales Person Modal -->
<div class="modal fade" id="kt_modal_inquiry_sales_person" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">Forward Inquiry to Sales Person</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="salesPersonForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <!-- Inquiry Information -->
          <div class="card mb-5" *ngIf="selectedInquiry">
            <div class="card-header">
              <h3 class="card-title">Inquiry Details</h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <strong>Customer:</strong> {{ selectedInquiry.name || '-' }}
                </div>
                <div class="col-md-6">
                  <strong>Email:</strong> {{ selectedInquiry.email || '-' }}
                </div>
                <div class="col-md-12 mt-2">
                  <strong>Message:</strong> {{ selectedInquiry.message || '-' }}
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <!-- Sales Person Dropdown -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Select Sales Person</label>
              <select
                class="form-select form-select-solid"
                formControlName="sales_person_id"
                [class.is-invalid]="sales_person_id?.invalid && sales_person_id?.touched">
                <option value="">Select Sales Person</option>
                <option *ngFor="let salesPerson of salesPersonList" [value]="salesPerson.value">
                  {{ salesPerson.label }}
                </option>
              </select>
              <div *ngIf="sales_person_id?.invalid && sales_person_id?.touched" class="invalid-feedback">
                <div *ngIf="sales_person_id?.errors?.['required']">Sales Person is required</div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light me-3"
            data-bs-dismiss="modal"
            [disabled]="isLoading">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            Forward Inquiry
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
